/**
 * Redux actions for the user interface.
 * @module redux/actions/userInterface
 */

import { createAction } from "redux-actions";
import Themes from "../themes/";

export const THEME_CHANGED = "UI/THEME_CHANGED";

export const changeTheme = themeName => dispatch => {
  const theme = Themes[themeName] ? Themes[themeName] : Themes.standard;

  return dispatch(createAction(THEME_CHANGED)({ themeName, theme }));
};

export const actions = {
  changeTheme
};



// WEBPACK FOOTER //
// ./app/actions/userInterface.js